module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = ../../../../readable-stream/lib/internal/streams/stream-browser.js
// module chunks = common